<mat-slider
  class="slider"
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [min]="templateOptions.min"
  [max]="templateOptions.max"
  [step]="templateOptions.step"
  [value]="templateOptions.value"
  [thumbLabel]="templateOptions.thumbLabel"
  [tabindex]="templateOptions.tabindex || 0"
  [displayWith]="templateOptions.displayWith"
>
</mat-slider>
